export const FORM_STATUS = {
    PUBLISH: 1
};

export const bgTypes = {
    COLOR: 1,
    IMG: 2
};
